// opervex-frontend/src/Opervex/MaterialManagement/index.js

import _products from "./Products";
import _categories from "./Categories";
import _storageLocation from "./StorageLocation";
import _goodsMovement from "./GoodsMovement";
import _stock from "./Stock";
import _stockSerial from "./StockSerial";
import _unitsMeasure from "./UnitsMeasure";

class MaterialMaster {
  #_api;

  constructor(api) {
    this.#_api = api;

    this.Products = new _products(this.#_api);
    this.Categories = new _categories(this.#_api);
    this.StorageLocation = new _storageLocation(this.#_api);
    this.GoodsMovement = new _goodsMovement(this.#_api);
    this.Stock = new _stock(this.#_api);
    this.UnitsMeasure = new _unitsMeasure(this.#_api);
    this.StockSerial = new _stockSerial(this.#_api);
  }
}

export default MaterialMaster;
